import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WeiboCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/WeiboCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var WeiboCircleOutlined = function WeiboCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WeiboCircleOutlined.displayName = 'WeiboCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(WeiboCircleOutlined);